<script>

export default {
    props: ['messages'],
    mounted() {
        let $notify = this.$notify;

        this.messages.forEach(msg => {
            $notify({
                group: 'base',
                text: msg.text,
                type: msg.type,
            });
        });
    },
};

</script>



// WEBPACK FOOTER //
// resources/assets/components/Alerts.vue